import { updateObject } from '../../lib';

const defaultReducer = (state, payload) => updateObject(state, payload);

export default defaultReducer;